import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BlogHeader() {
  return <section data-section-id="263098" id="blog-header" className="relative py-16 md:py-24 lg:py-32 overflow-hidden bg-primary flex items-center min-h-[50vh]">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_blog_banner.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_blog_banner.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_blog_banner.png-wvc-sizes" alt="International mobility and immigration insights" className="w-full h-full object-cover object-center" loading="lazy" />
        <div className="absolute inset-0 bg-primary/90"></div>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-tight font-default mb-6 max-w-5xl leading-tight">
          BLOG UFFICIALE <span className="text-secondary font-light mx-2 md:mx-4">/</span> WORLD IMMIGRATION
        </h1>
        
        <p className="text-lg sm:text-xl md:text-2xl text-secondary font-medium mb-10 max-w-3xl font-default">
          Approfondimenti e guide esperte sulla mobilità internazionale e visti
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 font-semibold bg-[#FFC829] text-primary hover:bg-[#FFC829]/90 rounded-md shadow-md">
            <Link to="/VisasAndImmigrationPage">Scopri i Servizi</Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto text-base h-12 px-8 border-secondary text-white hover:bg-secondary hover:text-secondary-foreground bg-transparent backdrop-blur-sm font-semibold rounded-md shadow-md">
            <Link to="/ContactsPage">Contattaci</Link>
          </Button>
        </div>
      </div>
    </section>;
}